let axios = window.axios
export default {

  /* 客户列表 */
  get_customers (page, params) {
    return axios.get('/erp/api.customer/index?page=' + page, {
      params: params
    })
  },
  /* 获取客户信息 */
  get_customer (id) {
    return axios.get('/erp/api.customer/info?id=' + id)
  },
  /* 编辑客户 */
  edit_customer (params) {
    return axios.post('/erp/api.customer/edit', params)
  },
  /* 新增客户 */
  add_customer (params) {
    return axios.post('/erp/api.customer/add', params)
  },
  /* 客户主营 */
  get_customer_business () {
    return axios.get('/erp/api.customer_business/index')
  },
  /* 客户类型 */
  get_customer_type () {
    return axios.get('/erp/api.customer_type/index')
  },
  /* 客户等级 */
  get_customer_levels () {
    return axios.get('/erp/api.customer_level/index')
  },
  /* 获取客户状态列表 */
  get_progress_status () {
    return axios.get('/erp/api.customer/get_progress_status')
  },

  /* 销售员列表 */
  get_salesmen () {
    return axios.get('/erp/api.staff/get_sellers')
  },

  /* 获取客户来源类型 */
  get_origin_types () {
    return axios.get('/erp/api.customer_origin/get_origin_type')
  },

  /* 获取客户来源平台 */
  get_origin_sites () {
    return axios.get('/erp/api.customer_origin/get_origin_site')
  },

  /* 获取图片标签 */
  get_image_tags () {
    return axios.get('/erp/api.customer_images/get_image_tags')
  },
  /* 添加图片 */
  add_image (id, urls) {
    return axios.post('/erp/api.customer_images/add', {
      customer_id: id,
      image_urls: urls
    })
  },
  /* 删除图片,因为element大图预览存在bug，不可以在带有预览列表的页面删除图片 */
  delete_image (id, url) {
    return axios.post('/erp/api.customer_images/delete', {
      customer_id: id,
      image_urls: url
    })
  },

  /* 获取地图api解析地址 */
  get_map_address (coordinate) {
    return axios.get('/erp/api.map/get_address_by_coordinate?coordinate=' + coordinate)
  },
  /* 获取地图api解析坐标 */
  get_map_coordinate (address) {
    return axios.get('/erp/api.map/get_coordinate_by_address?address=' + address)
  },
  /* 获取微信jssdk_config */
  get_jssdk_config ($params) {
    return axios.post('/erp/api.wechat/get_sdk_config', $params);
  }
}
